"use client";

import { useReportBoundaryError } from "@/shared/lib/use-report-boundary-error";
import { useTranslations } from "next-intl";

export default function MarketingError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const tUi = useTranslations("Ui");
  useReportBoundaryError(error, "marketing/error");

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-background px-4 text-center">
      <div className="space-y-2">
        <h2 className="text-3xl font-bold text-foreground">
          {tUi("error.chtoToPoshloNe")}
        </h2>
        <p className="text-muted-foreground">
          {error.message || tUi("litError.proizoshlaNepredvidennayaOshibka")}
        </p>
        {error.digest && (
          <p className="text-xs text-muted-foreground">
            ID: {error.digest}
          </p>
        )}
      </div>
      <div className="flex flex-wrap justify-center gap-3">
        <button
          onClick={reset}
          className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90"
        >
          {tUi("error.poprobovatSnova")}
        </button>
        <a
          href="/"
          className="rounded-md border border-border px-4 py-2 text-sm font-medium text-foreground hover:bg-muted"
        >
          {tUi("error.naGlavnuyu")}
        </a>
      </div>
    </div>
  );
}
